import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Customer } from '../models/customer.entity'

export type CustomerNotificationCode =
  | GenericNotificationCode
  | 'ADDRESS_NOT_FOUND'
  | 'CUSTOMER_DELETED'
  | 'CUSTOMER_NOT_FOUND'
  | 'CUSTOMER_SAVED'

export type CustomerModalCode = 'CUSTOMER_DELETION'

/**
 * Parse customer code to a notification
 * @param code - the customer notification code
 * @returns the notification options
 */
export function parseCustomerNotification(
  code?: CustomerNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'ADDRESS_NOT_FOUND':
      return {
        message: 'Address not found',
        color: 'error',
      }
    case 'CUSTOMER_DELETED':
      return {
        message: 'Customer deleted successfully',
        color: 'success',
      }
    case 'CUSTOMER_NOT_FOUND':
      return {
        message: 'Customer not found',
        color: 'error',
      }
    case 'CUSTOMER_SAVED':
      return {
        message: 'Customer saved successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse customer code to an modal
 * @param code - the customer modal code
 * @param customer - the customer object
 * @returns the modal settings
 */
export function parseCustomerModal(
  code: CustomerModalCode,
  customer?: Customer,
): DialogOptions {
  switch (code) {
    case 'CUSTOMER_DELETION': {
      const cusName = customer?.name
      return {
        title: 'Delete customer',
        message:
          'You are about to delete the customer <strong>%s</strong>. Proceed with deletion?',
        messageParams: cusName ? [cusName] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
